import * as Yup from 'yup'

export const validationSchema = {
  user_name: Yup.string().required('请输入帐号'),
  password: Yup.string().required('请输入密码'),
}
